import { Injectable, inject } from "@angular/core";

import { CountriesApiService } from "@components/shared/countries/api";
import { RiskAssessmentReportRecord } from "@components/shared/risk-assessment-reports/models";
import { RiskAssessmentTemplateResourceType } from "@components/shared/risk-assessment-templates/constants";
import { AuthenticationService, CommonService, ConnectionsService } from "@shared/services";

type Params = {
  id: string;
  countryCode?: string;
};

@Injectable({
  providedIn: "root",
})
export class OrganisationRiskAssessmentReportRelatedRecordsService {
  private readonly commonService = inject(CommonService);

  private readonly authService = inject(AuthenticationService);

  private readonly connectionsService = inject(ConnectionsService);

  private readonly countriesApi = inject(CountriesApiService);

  async get({ id, countryCode }: Params): Promise<RiskAssessmentReportRecord["record"][]> {
    if (!this.authService.isRegularUser) {
      return null;
    }

    if (!countryCode) {
      const { address } = await this.connectionsService.get(id);

      countryCode = address.country;
    }

    const { content } = await this.countriesApi.getAll({ code: countryCode });

    const country = content[0] ?? {
      id: null,
      name: this.commonService.getCountryName(countryCode),
      code: countryCode,
    };

    return [{ ...country, type: RiskAssessmentTemplateResourceType.COUNTRY }];
  }
}
